export default __webpack_public_path__ + "static/media/messageme.c17be5c4.svg";